export const PolicyEditConstants = {
  continue: 'Continue',
  cancel: 'Cancel',
  pendingEndorsementChangesConfirmationMessage: 'There are pending endorsement changes. Go to the Issue page to see changes.',
  titleInformation: 'Endorsement Changes'
};